import React, { Fragment } from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navbar8 from '../components/navbar8'
import Hero4 from '../components/hero4'
import Hero17 from '../components/hero17'
import Testimonial17 from '../components/testimonial17'
import Footer4 from '../components/footer4'
import './home.css'

const Home = (props) => {
  return (
    <div className="home-container1">
      <Helmet>
        <title>Quaalude Runner</title>
        <meta
          name="description"
          content="Wolf of Wallstreet meets Play2Earn. Epic game where winners earn a slice of revenue on chain."
        />
        <meta property="og:title" content="Quaalude Runner" />
        <meta
          property="og:description"
          content="Wolf of Wallstreet meets Play2Earn. Epic game where winners earn a slice of revenue on chain."
        />
      </Helmet>
      <Navbar8
        link1={
          <Fragment>
            <span className="home-text10">#home</span>
          </Fragment>
        }
        link2={
          <Fragment>
            <span className="home-text11">#about</span>
          </Fragment>
        }
        link3={
          <Fragment>
            <span className="home-text12">#services</span>
          </Fragment>
        }
        link4={
          <Fragment>
            <span className="home-text13">#contact</span>
          </Fragment>
        }
        page1={
          <Fragment>
            <span className="home-text14">Home</span>
          </Fragment>
        }
        page2={
          <Fragment>
            <span className="home-text15">About</span>
          </Fragment>
        }
        page3={
          <Fragment>
            <span className="home-text16">Services</span>
          </Fragment>
        }
        page4={
          <Fragment>
            <span className="home-text17">Contact</span>
          </Fragment>
        }
        action1={
          <Fragment>
            <span className="home-text18">Explore Now</span>
          </Fragment>
        }
        action2={
          <Fragment>
            <span className="home-text19">Contact Us</span>
          </Fragment>
        }
        page1Description={
          <Fragment>
            <span className="home-text20">Welcome to our Home page</span>
          </Fragment>
        }
        page2Description={
          <Fragment>
            <span className="home-text21">Learn more About us</span>
          </Fragment>
        }
        page3Description={
          <Fragment>
            <span className="home-text22">Check out our Services</span>
          </Fragment>
        }
        page4Description={
          <Fragment>
            <span className="home-text23">Get in touch with us</span>
          </Fragment>
        }
        rootClassName="navbar8root-class-name"
      ></Navbar8>
      <Hero4
        action1={
          <Fragment>
            <span className="home-text24">Buy Now</span>
          </Fragment>
        }
        action2={
          <Fragment>
            <span className="home-text25">Visit X</span>
          </Fragment>
        }
        content1={
          <Fragment>
            <span className="home-text26">
              The top wallet on the leaderboard gets daily payouts from the
              creator rewards on Pump Fun
            </span>
          </Fragment>
        }
        heading1={
          <Fragment>
            <span className="home-text27">
              Quaalude Runner  a Play 2 Earn Game
            </span>
          </Fragment>
        }
      ></Hero4>
      <div className="home-container2">
        <div className="home-container3">
          <div className="home-container4">
            <Script
              html={`<iframe width="100%" height="100%" src="https://www.youtube.com/embed/L7btKdFOs5w?si=-hcLKUJich6u-x9e" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>`}
            ></Script>
          </div>
        </div>
      </div>
      <Hero17
        action1={
          <Fragment>
            <span className="home-text28">Buy Now</span>
          </Fragment>
        }
        action2={
          <Fragment>
            <span className="home-text29">Visit X</span>
          </Fragment>
        }
        content1={
          <Fragment>
            <span className="home-text30">
              Don&apos;t be a sober bitch. Buy the coin.
            </span>
          </Fragment>
        }
        heading1={
          <Fragment>
            <span className="home-text31">CA Goes Here</span>
          </Fragment>
        }
      ></Hero17>
      <Testimonial17
        review1={
          <Fragment>
            <span className="home-text32">
              There&apos;s no nobility in poverty. I&apos;ve been a rich man and
              I&apos;ve been a poor man, and I choose rich every fucking time.
            </span>
          </Fragment>
        }
        review2={
          <Fragment>
            <span className="home-text33">
              I smoke crack, Jordan. You know... on my way to the office. But,
              nobody&apos;s perfect.
            </span>
          </Fragment>
        }
        review3={
          <Fragment>
            <span className="home-text34">
              These little bastards were so strong I discovered a whole new
              phase — the Cerebral Palsy Phase.”
              <span
                dangerouslySetInnerHTML={{
                  __html: ' ',
                }}
              />
            </span>
          </Fragment>
        }
        review4={
          <Fragment>
            <span className="home-text35">
              Fugayzi, fugazi… it’s a wazi, it’s a woozie—fairy-dust. It doesn’t
              exist. It’s never landed, it’s no matter, it’s not on the
              elemental chart… it’s not… real.
            </span>
          </Fragment>
        }
        content1={
          <Fragment>
            <span className="home-text36">That movie funny AF</span>
          </Fragment>
        }
        heading1={
          <Fragment>
            <span className="home-text37">Quotes</span>
          </Fragment>
        }
        author1Name={
          <Fragment>
            <span className="home-text38">Jordan</span>
          </Fragment>
        }
        author2Name={
          <Fragment>
            <span className="home-text39">Donnie</span>
          </Fragment>
        }
        author3Name={
          <Fragment>
            <span className="home-text40">Jordan</span>
          </Fragment>
        }
        author4Name={
          <Fragment>
            <span className="home-text41">Mark Hanna</span>
          </Fragment>
        }
        author1Position={
          <Fragment>
            <span className="home-text42">Based Chad</span>
          </Fragment>
        }
        author2Position={
          <Fragment>
            <span className="home-text43">Resident Crackhead</span>
          </Fragment>
        }
        author3Position={
          <Fragment>
            <span className="home-text44">Based Chad</span>
          </Fragment>
        }
        author4Position={
          <Fragment>
            <span className="home-text45">Crypto Trader</span>
          </Fragment>
        }
        author1Src="/oip%20(13)-1500h.jpeg"
        author2Src="/oip%20(14)-200h.jpeg"
        author3Src="/oip%20(12)-200h.jpeg"
      ></Testimonial17>
      <Footer4
        link1={
          <Fragment>
            <span className="home-text46">Buy</span>
          </Fragment>
        }
        link2={
          <Fragment>
            <span className="home-text47">X</span>
          </Fragment>
        }
        link3={
          <Fragment>
            <span className="home-text48">Twitter</span>
          </Fragment>
        }
        termsLink={
          <Fragment>
            <span className="home-text49">Terms and Conditions</span>
          </Fragment>
        }
        cookiesLink={
          <Fragment>
            <span className="home-text50">Cookies Policy</span>
          </Fragment>
        }
        privacyLink={
          <Fragment>
            <span className="home-text51">Privacy Policy</span>
          </Fragment>
        }
        logoSrc="/oip%20(13)-1500h.jpeg"
        imageSrc="/oip%20(13)-1500h.jpeg"
      ></Footer4>
    </div>
  )
}

export default Home
